<template>
  <div style="min-width:1000px;">
    <section>
      <div class="jczl_div">
        <span class="jczl_span1">
          设备管理
        </span>
        <br />
        <span class="jczl_span2">
          当前有 {{total}} 个设备已登记
        </span>
      </div>
      <!--工具条-->
      <el-col :span="24">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-select class="souch_change" v-model="value" placeholder="请选择" @change="changeSouch" clearable>
            <el-option v-for="item in options" :key="item.value" 
              :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-form-item>
            <el-input class="souch_change souch_input" v-model="proName"  @keyup.enter.native="getList(1)" style="width:200px;"></el-input>
          </el-form-item> 
          <el-form-item>
            <el-button type="primary" class="souch_but" v-on:click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="adds souch_but2" @click="handleAdd">新增</el-button>
          </el-form-item>  
        </el-form>
        <el-tag :key="tag" v-for="tag in dynamicTags" closable 
          :disable-transitions="false" @close="handleClose(tag)"> 
            {{tag}} 
        </el-tag>
        <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button>
      </el-col>

      <!--列表-->
      <el-table tooltip-effect="dark" :data="proList" highlight-current-row v-loading="listLoading" style="width: 100%;"
         @selection-change="selsChange" :header-cell-style="getRowClass" @sort-change="handleSortChange">
        <el-table-column type="index" :index="indexMethod" label="序号" width="100">
          <template slot-scope="scope">
              <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="hardHash" label="设备硬件码" min-width="300" sortable="custom" show-overflow-tooltip >
        </el-table-column>
        <el-table-column prop="deptname" label="部门" min-width="150" sortable="custom" show-overflow-tooltip >
        </el-table-column>
        <el-table-column prop="comment" label="备注" min-width="220" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="intime" label="添加时间" min-width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        
        <el-table-column label="操作" min-width="200" style="text-algin:center">
          <template slot-scope="scope">
            <el-button class="editbut" type="primary" plain size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button class="delbut" type="info" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="border:1px solid #dfe6ec;">
        <el-pagination 
          background
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50,100]"
          :current-page="pageNumber" 
          @current-change="handleCurrentChange" 
          @size-change="handleSizeChange"
          :page-size="pageSize"
          :total="total" 
          style="float:right;">
        </el-pagination>
      </el-col>

      <!--新增界面-->
      <el-dialog class="model-edit" title="新增设备" :visible.sync="addFormVisible" 
        :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-row>
            <el-col :span="22"> 
              <el-form-item label="硬件码" prop="hardHash">
                <el-input v-model="addForm.hardHash" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="部门" > 
                <el-input  v-model="addForm.deptname" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="备注" prop="comment"> 
                <el-input type="textarea" :rows="4" v-model="addForm.comment" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button class="qxsub" @click.native="addFormVisible = false">取消</el-button>
          <el-button class="addsub" type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--编辑界面-->
      <el-dialog class="model-edit" title="编辑设备" :visible.sync="editFormVisible" 
        :close-on-click-modal="false">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-row>
            
            <el-col :span="22"> 
              <el-form-item label="硬件码" prop="hardHash">
                <el-input v-model="editForm.hardHash" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="部门" > 
                <el-input  v-model="editForm.deptname" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="备注" prop="comment"> 
                <el-input type="textarea" :rows="4" v-model="editForm.comment" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button  class="qxsub" @click.native="editFormVisible = false">取消</el-button>
          <el-button class="addsub" type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>
  </div>
</template>
<script>


import { API__code,API_Company,API__account} from '../../../api/index.js'
export default {
  inject:['reload'],
  data(){
    return{
      companymanageid:'',//企业id
      souchs:{
        hardHash:'',
        comment:'',
        deptname:'',
      },
      dynamicTags:[],
      proName:'',
      options: [
        {value: '硬件码',label: '硬件码'}, 
        {value: '部门',label: '部门'}, 
        {value: '备注',label: '备注'},
      ],
      value:"",
      token:'',
      checkCode:'',
      id:'',
      total:0,
      pageSize:10,
      pageNumber:1,
      proList:[],
      listLoading:false,
      sels:[],
      addFormVisible:false,
      addForm:{
        hardHash:'',
        comment:'',
        deptname:''
      },
      addLoading:false,
      addFormRules:{
        hardHash: [
          { required: true, message: '请输入硬件码', trigger: 'blur' }
        ],
      },
      editFormVisible:false,
      editForm:{
        hardHash:'',
        comment:'',
        deptname:''
      },
      editLoading:false,
      editFormRules:{
        hardHash: [
          { required: true, message: '请输入硬件码', trigger: 'blur' }
        ],
      },
      orderType:"",
      orderStr:'',
    }
  },
  methods:{
    handleSortChange:function(val){
      if(val){
        if(val.prop == "hardHash"){
          this.orderStr = "hardHashpx";
        }else if(val.prop == "comment"){
          this.orderStr = "commentpx";
        }else if(val.prop == "intime"){
          this.orderStr = "intimepx";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getList();
    },
    changeSouch:function(val){
      if(val == "硬件码"){
        this.proName = this.souchs.hardHash;
      }else if(val == "备注"){
        this.proName = this.souchs.comment;
      }else if(val == "部门"){
        this.proName = this.souchs.deptname;
      }
    },
    delTags:function(){
      this.souchs = {},
      this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getList();
    },
    handleClose(tag) {
      if(tag == "硬件码"){
        this.souchs.hardHash ="";
        if(this.value == "硬件码"){
          this.proName = '';
        }
      }
      if(tag == "部门"){
        this.souchs.deptname ="";
        if(this.value == "部门"){
          this.proName = '';
        }
      }
      if(tag == "备注"){
        this.souchs.comment ="";
        if(this.value == "备注"){
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    editSubmit:function(){
      if(!this.editForm.hardHash){
        this.$message.error('硬件码不可为空！');
        return;
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        mode:'',
        id:this.editForm.id,
        comment:this.editForm.comment,
        hardHash:this.editForm.hardHash,
        deptname:this.editForm.deptname,
        companyid:this.companymanageid,
      }
      this.editLoading = true;
      API_Company.addSBList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: "保存成功",
            type: 'success'
          });
          this.getList();
          this.editFormVisible = false;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.editLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.editLoading = false;
      })
    },
    addSubmit:function(){
      if(!this.addForm.hardHash){
        this.$message.error('硬件码不可为空！');
        return;
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        mode:'save',
        comment:this.addForm.comment,
        hardHash:this.addForm.hardHash,
        deptname:this.addForm.deptname,
        companyid:this.companymanageid,
      }
      this.addLoading = true;
      API_Company.addSBList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: "保存成功",
            type: 'success'
          });
          this.getList();
          this.addFormVisible = false;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.addLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.addLoading = false;
      })
    },
    handleDel:function(index,row){
      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          id:row.id,
        }
        API_Company.delSBList(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: "删除成功",
              type: 'success'
            });
            this.getList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'login'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(err =>{
      });
    },
    handleEdit:function(index,row){
      this.editForm = Object.assign({}, row);
      this.editFormVisible = true;
    },
    handleAdd:function(){
      this.addForm = {};
      this.addFormVisible = true;
    },
    getList:function(val){
      if(this.value == "硬件码"){
        this.souchs.hardHash = this.proName;
      }
      if(this.value == "部门"){
        this.souchs.deptname = this.proName;
      }
      if(this.value == "备注"){
        this.souchs.comment = this.proName;
      }
      var flag = true;
      if(val == 1){
        this.pageNumber = 1;
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        listType: 'page',
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
        // companyid:sessionStorage.getItem('companymanageid'),
        companyid:this.companymanageid,
        comment:this.souchs.comment,
        hardHash:this.souchs.hardHash,
        deptname:this.souchs.deptname,
        orderType:this.orderType,
        orderStr:this.orderStr,
      }
      this.listLoading = true;
      API_Company.getSBList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          // if(res.data.data.list){
            this.proList = res.data.data.list;
            this.total = res.data.data.totalRow;
          // }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnypt_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnypt_checkCode') {
              this.checkCode = arr2[1];
          }
          // else if (arr2[0] == 'dnnypt_id') {
          //     this.id = arr2[1];
          // }
        }
      }
    },
    getDetial:function(){
      let _this = this;
      let params = {
        token:this.token,
        checkCode:this.checkCode,
        id:sessionStorage.getItem('dnnypt_id'),
      }
      API__account.accountDetail(params)
      .then((res)=>{
        if(res.data.code == API__code.SUCCESS){
          let data =  res.data.data;
          if(data.companymanageid || data.companyuseid) {
            let data =  res.data.data;
            // 部门管理员登录： 取companyuseid
            _this.companymanageid = data.companymanageid? data.companymanageid: data.companyuseid;
           _this.getList();
          }else if(res.data.data.deptList && res.data.data.deptList.length > 0) {
             _this.getList();
          }else{
            this.$router.push({path: 'management'});
            this.reload();
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    }
  },
  mounted(){
    this.getDetial();
  },
  created(){
    this.getCookie();
  },

}
</script>
<style lang="scss" scoped>
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.float_left{
	float: left;
}
.jczl_div{
    height: 100px;
    width: 100%;
    position: relative;
    left: 20px;
  }
.jczl_span1{
  font-size:20px;
  color:#666;
  font-weight:bold;
  position: relative;
  top:20px;
}
.jczl_span2{
  font-size:14px;
  color:#666;
  font-weight:normal;
  position: relative;
  top:30px;
}
.souch_but{
  width:96px;
  background: #F66B3D;
  height: 40px;
  position: relative;
  left: -25px;
  border-radius: 0;
  border-color: #f66b3d;
  &:hover{
      background: #fc8b65;
      border-color: #fc8b65;
  }
}
.souch_but2{
  width:96px;
  background: #fff;
  height: 40px;
  position: relative;
  left: 0px;
  color:#F66B3D;
  border-radius: 0;
  border-color: #fff;
  &:hover{
      background: rgb(243, 229, 229);
      border-color: #fc8b65;
  }
}
.souch_input{
  width:200px;
  position: relative;
  left: -10px;
}
.addsub{
  background: #F66B3D;
  border-color: #F66B3D;
  &:hover{
      background: #fc8b65;
      border-color: #fc8b65;
  }
}
.qxsub{
  background: #fff;
  color:#F66B3D;
  border-color: #fc8b65;
  &:hover{
      background: rgb(243, 229, 229);
      border-color: #fc8b65;
  }
}
</style>




// WEBPACK FOOTER //
// Device.vue?6e65ef87